import NProgress from 'nprogress'
import routeGuards from './guards'

const routerFunction = (store, VueRouter) => {

	const guards = routeGuards(store)


	const routes = [


		/*
		|--------------------------------------------------------------------------
		| Home Page
		|--------------------------------------------------------------------------
		*/
		{
			path: "/",
			name: "Index",
			component: () => import("../views/public/Home.vue")
		},
		/*
		|--------------------------------------------------------------------------
		| Public Layanan
		|--------------------------------------------------------------------------
		*/
		{
			path: "/layanan",
			name: "Layanan",
			component: () => import("../views/public/layanan/Home.vue")
		},
		{
			path: "/layanan/:slugpaket",
			name: "ListLayanan",
			component: () => import("../views/public/layanan/ListLayanan.vue")
		},
		{
			path: "/layanan/:slugpaket/:sluglayanan",
			name: "DetailLayanan",
			component: () => import("../views/public/layanan/DetailLayanan.vue")
		},

		/*
		|--------------------------------------------------------------------------
		| Public Berita
		|--------------------------------------------------------------------------
		*/
		{
			path: "/berita",
			name: "Berita",
			component: () => import("../views/public/berita/Berita.vue")
		},
		{
			path: "/berita/:slug",
			name: "DetailBerita",
			component: () => import("../views/public/berita/DetailBerita.vue")
		},


		/*
		|--------------------------------------------------------------------------
		| Auth
		|--------------------------------------------------------------------------
		*/
		{
			path: "/login",
			name: "Login",
			component: () => import("../views/auth/Login.vue"),
			beforeEnter: guards.publicGuard
		},
		{
			path: "/register",
			name: "Register",
			component: () => import("../views/auth/Register.vue"),
			beforeEnter: guards.publicGuard
		},
		{
			path: "/verifikasi-email",
			name: "VerifikasiEmail",
			component: () => import("../views/auth/VerifikasiEmail.vue")
		},
		{
			path: "/devel0per0nly",
			name: "LoginDeveloper",
			component: () => import("../views/auth/LoginDeveloper.vue"),
			beforeEnter: guards.publicGuard
		},









		/*
		|--------------------------------------------------------------------------
		| Route Authenticated User
		|--------------------------------------------------------------------------
		*/
		{
			path: "/profil",
			name: "Profil",
			component: () => import("../views/auth/Profil.vue")
		},


		/*
		|--------------------------------------------------------------------------
		| Route Check Role
		|--------------------------------------------------------------------------
		| Route ini hanya untuk menangani redirect halaman sesuai role saja
		|
		*/
		{
			path: "/home",
			name: "Home",
			component: () => import("../views/page/Redirect.vue"),
			beforeEnter: guards.checkRole
		},

		/*
		|--------------------------------------------------------------------------
		| Route Home Page User Auth
		|--------------------------------------------------------------------------
		*/
		{
			path: "/penduduk",
			name: "HomePenduduk",
			component: () => import("../views/home/Penduduk.vue"),
			beforeEnter: guards.pendudukGuard
		},
		// sepertinya tidak ada
		{
			path: "/kepala-dusun",
			name: "HomeKepalaDusun",
			component: () => import("../views/home/KepalaDusun.vue"),
			beforeEnter: guards.kepalaDusunGuard
		},
		{
			path: "/operator-desa",
			name: "HomeOperatorDesa",
			component: () => import("../views/home/OperatorDesa.vue"),
			beforeEnter: guards.desaGuard
		},
		{
			path: "/kepala-desa",
			name: "HomeKepalaDesa",
			component: () => import("../views/home/KepalaDesa.vue"),
			beforeEnter: guards.kepalaDesaGuard
		},
		{
			path: "/operator-kecamatan",
			name: "HomeOperatorKecamatan",
			component: () => import("../views/home/OperatorKecamatan.vue"),
			beforeEnter: guards.kecamatanGuard
		},
		{
			path: "/operator-dukcapil",
			name: "HomeOperatorDukcapil",
			component: () => import("../views/home/OperatorDukcapil.vue"),
			beforeEnter: guards.dukcapilGuard
		},
		{
			path: "/admin",
			name: "HomeAdmin",
			component: () => import("../views/home/Admin.vue"),
			beforeEnter: guards.adminGuard
		},
		{
			path: "/umkm",
			name: "HomeUmkm",
			component: () => import("../views/home/Umkm.vue"),
			beforeEnter: guards.umkmGuard
		},
		{
			path: "/jasa-antar",
			name: "HomeJasaAntar",
			component: () => import("../views/home/JasaAntar.vue"),
			beforeEnter: guards.jasaAntarGuard
		},
		{
			path: "/rumah-sakit",
			name: "HomeRumahSakit",
			component: () => import("../views/home/RumahSakit.vue"),
			beforeEnter: guards.rumahSakitGuard
		},


		/*
		|--------------------------------------------------------------------------
		| Route Layanan Layout Admin
		|--------------------------------------------------------------------------
		*/
		{
			path: "/info-layanan",
			name: "InfoLayanan",
			component: () => import("../views/infolayanan/Home.vue")
		},
		{
			path: "/info-layanan/:paket",
			name: "ListInfoLayanan",
			component: () => import("../views/infolayanan/ListInfoLayanan.vue")
		},
		{
			path: "/info-layanan/:paket/:layanan",
			name: "DetailInfoLayanan",
			component: () => import("../views/infolayanan/DetailInfoLayanan.vue")
		},





		/*
		|--------------------------------------------------------------------------
		| Kependudukan
		|--------------------------------------------------------------------------
		*/
		{
			path: "/kependudukan/sinkronisasi",
			name: "KependudukanSinkronisasi",
			component: () => import("../views/kependudukan/SinkronisasiPenduduk.vue"),
			beforeEnter: guards.adminAndDukcapilGuard
		},
		{
			path: "/kependudukan/generate-otp",
			name: "KependudukanGenerateOtp",
			component: () => import("../views/kependudukan/GenerateOtp.vue"),
			beforeEnter: guards.desaAndAdminGuard
		},
		{
			path: "/kependudukan/data-penduduk",
			name: "KependudukanDataPenduduk",
			component: () => import("../views/kependudukan/DataPenduduk.vue"),
			beforeEnter: guards.adminAndDukcapilGuard
		},
		{
			path: "/kependudukan/akun-penduduk",
			name: "KependudukanAkunPenduduk",
			component: () => import("../views/kependudukan/AkunPenduduk.vue"),
			beforeEnter: guards.operatorGuard
		},
		// ini diakses oleh penduduk saja
		{
			path: "/kependudukan/validasi-otp",
			name: "KependudukanValidasiOtp",
			component: () => import("../views/kependudukan/ValidasiOtp.vue")
		},



		/*
		|--------------------------------------------------------------------------
		| Profil Desa
		|--------------------------------------------------------------------------
		*/
		{
			path: "/profil-desa",
			name: "ProfilDesa",
			component: () => import("../views/profildesa/ProfilDesa.vue"),
			beforeEnter: guards.desaGuard
		},


		/*
		|--------------------------------------------------------------------------
		| Admin Berita
		|--------------------------------------------------------------------------
		*/
		{
			path: "/admin/berita",
			name: "AdminBerita",
			component: () => import("../views/berita/Berita.vue"),
			beforeEnter: guards.adminAndDukcapilGuard
		},
		{
			path: "/admin/berita/:slug",
			name: "AdminLihatBerita",
			component: () => import("../views/berita/LihatBerita.vue"),
			beforeEnter: guards.adminAndDukcapilGuard
		},

		/*
		|--------------------------------------------------------------------------
		| Panduan (Dari Berita)
		|--------------------------------------------------------------------------
		*/
		{
			path: "/panduan",
			name: "PanduanAplikasi",
			component: () => import("../views/panduan/Panduan.vue"),
			beforeEnter: guards.authGuard
		},
		{
			path: "/panduan/:slug",
			name: "PanduanAplikasiDetail",
			component: () => import("../views/panduan/DetailPanduan.vue"),
			beforeEnter: guards.authGuard
		},



		/*
		|--------------------------------------------------------------------------
		| Admin Page
		|--------------------------------------------------------------------------
		*/
		{
			path: "/admin/page/:slug",
			name: "AdminLihatPage",
			component: () => import("../views/pagelaman/LihatPage.vue")
		},



		/*
		|--------------------------------------------------------------------------
		| Report
		|--------------------------------------------------------------------------
		*/
		{
			path: "/report/jumlah-permohonan",
			name: "ReportJumlahPermohonan",
			component: () => import("../views/report/ReportJumlahPermohonan.vue"),
			beforeEnter: guards.operatorGuard
		},
		{
			path: "/report/status-permohonan",
			name: "ReportStatusPermohonan",
			component: () => import("../views/report/ReportStatusPermohonan.vue"),
			beforeEnter: guards.operatorGuard
		},

		/*
		|--------------------------------------------------------------------------
		| Permohonan
		|--------------------------------------------------------------------------
		*/
		{
			path: "/permohonan/buat-permohonan",
			name: "PermohonanBuatPermohonan",
			component: () => import("../views/permohonan/BuatPermohonan.vue"),
			beforeEnter: guards.authGuard
		},
		{
			path: "/permohonan/detail-permohonan/:id",
			props: true,
			name: "PermohonanDetailPermohonan",
			component: () => import("../views/permohonan/DetailPermohonan.vue"),
			beforeEnter: guards.authGuard
		},
		{
			path: "/permohonan/data-permohonan",
			name: "PermohonanDataPermohonan",
			component: () => import("../views/permohonan/DataPermohonan.vue"),
			beforeEnter: guards.authGuard
		},
		{
			path: "/permohonan/riwayat-input",
			name: "PermohonanRiwayatInput",
			component: () => import("../views/permohonan/RiwayatInputPermohonan.vue"),
			beforeEnter: guards.desaAndRsGuard
		},











		/*
		|--------------------------------------------------------------------------
		| Route Log
		|--------------------------------------------------------------------------
		| Saat ini hanya admin yg dapat mengakses
		| 
		|
		*/
		{
			path: "/log",
			name: "LogSistem",
			component: () => import("../views/log/Index.vue"),
			beforeEnter: guards.adminGuard
		},
    {
			path: "/file",
			name: "File",
			component: () => import("../views/file/Index.vue"),
			beforeEnter: guards.adminGuard
		},



		/*
		|--------------------------------------------------------------------------
		| Route Admin
		|--------------------------------------------------------------------------
		|
		| 
		|
		*/
		{
			path: "/admin/opsi-revisi",
			name: "AdminOpsiRevisi",
			component: () => import("../views/admin/OpsiRevisi.vue"),
			beforeEnter: guards.adminGuard
		},
		{
			path: "/admin/isian-form",
			name: "AdminIsianForm",
			component: () => import("../views/admin/IsianForm.vue"),
			beforeEnter: guards.adminGuard
		},
		// ini gak jadi dipake
		{
			path: "/sistem/mapping-layanan-form-pendaftaran",
			name: "SistemMamppingLayananFormPendaftaran",
			component: () => import("../views/sistem/SistemMappingLayananFormPendaftaran.vue"),
			beforeEnter: guards.adminGuard
		},



        /*
		|--------------------------------------------------------------------------
		| Route UMKM
		|--------------------------------------------------------------------------
		*/
        {
			path: "/umkm-profile",
			name: "UmkmProfile",
			component: () => import("../views/umkm/Profil.vue"),
			beforeEnter: guards.umkmGuard
		},
        {
			path: "/umkm-menu",
			name: "UmkmMenu",
			component: () => import("../views/umkm/Menu.vue"),
			beforeEnter: guards.umkmGuard
		},


        /*
		|--------------------------------------------------------------------------
		| Route Pesanan Menu
		|--------------------------------------------------------------------------
		*/
		{
			path: "/pesanan",
			name: "Pesanan",
			component: () => import("../views/pesanan/Pesanan.vue")
		},



		/*
		|--------------------------------------------------------------------------
		| Route Testing
		|--------------------------------------------------------------------------
		*/
		{
			path: "/test",
			name: "Test",
			component: () => import("../views/test/Index.vue")
		},

        


		/*
		|--------------------------------------------------------------------------
		| Route Error Page
		|--------------------------------------------------------------------------
		*/
		{
			path: "/403",
			name: "403",
			component: () => import("../views/page/403.vue")
		},
		{
			path: "/500",
			name: "500",
			component: () => import("../views/page/500.vue")
		},
		{
			path: "/*",
			name: "404",
			component: () => import("../views/page/404.vue")
		},



       
	];


	const router = new VueRouter({
		mode: "history",
		base: "/",
		routes,
		linkActiveClass: "active",
	})
	router.beforeEach((to, from, next) => {
		NProgress.start()
		NProgress.set(0.1)

		// spinner
		const loader = document.createElement('div')
		loader.innerHTML = '<div class="overlay-page-loader"><div class="spinner"></div></div>'
		document.querySelector('#app').appendChild(loader)

		// jaga jaga siapa tau gak ilang spinnernya
		setTimeout(() => {
			if (document.querySelector('.overlay-page-loader')) {
				document.querySelector('.overlay-page-loader').remove()
			}
		}, 1000)

		// next
		setTimeout(() => {
			next()
		}, 500)


	})
	router.afterEach(() => {
		setTimeout(() => NProgress.done(), 500)
		setTimeout(() => {
			if (document.querySelector('.overlay-page-loader')) {
				document.querySelector('.overlay-page-loader').remove()
			}
		}, 500)

	})

	return router
}

export default routerFunction